export interface ServiceFunction {
  sf_id: number;
  service_function_id: number;
  service_function_name: string;
  rec_create_date: string;
  rec_actual_date: string;
  create_date: string;
  update_date: string;
  version_number: string;
  commentary: string;
  changed_by: number;
  is_visible: number;
  description: string;
  created_by_user: string;
  updated_by_user: string;
}

// Квалификации сотрудников: GET /schedules/work_types/
export interface IWorkType {
  id: string;
  description: string;
  created_at: string;
  updated_at: string | null;
}

export interface IWorkTypesResponse {
  data: {
    work_types: IWorkType[];
  };
  metadata: {
    code: number;
    message: string;
  };
}

export interface IQualification {
  id: string;
  name: string;
}

export interface IUserQualificationsParams {
  user_id?: (number | string)[];
  work_type_id?: (number | string)[];
}

/**
 * Ответ GET /admin/users/qualifications/. Гарантированы только user_id
 * и work_type_id (они же параметры фильтра); поля с ФИО — предположение,
 * поэтому все опциональны, а имя при их отсутствии подменяется на user_id
 */
export interface IUserQualification {
  user_id: number;
  work_type_id: string;
  full_name?: string;
  employee_name?: string;
  last_name?: string;
  first_name?: string;
  patronymic_name?: string;
}

/**
 * Строка экрана «Квалификации»: сотрудник из справочника, его текущий
 * набор кодов квалификаций и состояние встроенного редактора
 */
export interface IQualificationEmployeeRow {
  userId: number;
  name: string;
  codes: string[];
  /**
   * Набор кодов реально получен с бэкенда. Пока false, редактирование
   * заблокировано: сохранение пустых галочек стёрло бы настоящий набор
   */
  codesLoaded: boolean;
  // Длинный список квалификаций в ячейке свёрнут до нескольких плашек
  isExpanded: boolean;
  isEditing: boolean;
  isSaving: boolean;
  checkedCodes: { [code: string]: boolean };
}

export const USERS_PATHS = {
  service_functions: 'users/service_functions',
  users: 'users',
  users_create: 'users/create',
  users_edit: 'users/:u_id',
};
